import { api, setMsg } from "../scripts/api.js";

class AppProfile extends HTMLElement {
   connectedCallback() {
      this.innerHTML = `
         <section id="profile">
            <div class="page-head">
               <h1>My profile</h1>
               <p class="sub" id="profile-sub">Loading…</p>
            </div>
 
            <div class="card">
               <h3 class="card-title">Scoreboard nickname</h3>
               <p class="card-hint">This is how you appear on live scoreboards. Free to choose — pick something your professor will recognize.</p>
               <label for="nickname">Nickname</label>
               <div class="row">
                  <input type="text" id="nickname" placeholder="Enter your new nickname...">
                  <button id="btn-nickname">Save</button>
               </div>
               <div class="msg" id="nickname-msg"></div>
            </div>
         </section>
      `;

      this.querySelector("#btn-nickname").addEventListener("click", () => this.save());
   }

   show() {
      if (this.loaded) return;
      this.loaded = true;
      this.load();
   }

   async load() {
      try {
         const res = await api("/me");
         if (!res.ok) throw new Error("me failed");
         const me = await res.json();
         if (!me.ok) throw new Error("bad /me");
         this.savedNickname = me.nickname || "";
         this.email = me.email;
         this.role = me.role;
         this.renderSubtitle();
         this.querySelector("#nickname").value = "";
      } catch (err) {
         console.error("profile load failed:", err);
         const sub = this.querySelector("#profile-sub");
         if (sub) sub.textContent = "Couldn't load your profile.";
      }
   }

   renderSubtitle() {
      const sub = this.querySelector("#profile-sub");
      if (!sub) return;
      sub.textContent = `${this.email} · `;

      const role = document.createElement("span");
      role.className = "role-pill";
      role.textContent = this.role;
      sub.appendChild(role);

      sub.append(" · ");
      const nick = document.createElement("span");
      nick.className = this.savedNickname ? "nickname-pill" : "nickname-pill empty";
      nick.textContent = this.savedNickname || "no nickname yet";
      sub.appendChild(nick);
   }

   async save() {
      const input = this.querySelector("#nickname");
      const btn = this.querySelector("#btn-nickname");
      const nickname = input.value.trim();
      if (!nickname) return setMsg("nickname-msg", "Nickname can't be empty.", "err");

      btn.disabled = true;
      setMsg("nickname-msg", "Saving...");
      try {
         const res = await api("/me/nickname", {
            method: "PATCH",
            body: JSON.stringify({ nickname }),
         });
         const data = await res.json();
         if (!res.ok || !data.ok) {
            const msg = {
               taken: "That nickname is taken. Try another.",
               invalid_nickname: "That nickname isn't valid.",
            }[data.reason] || "Couldn't save nickname.";
            return setMsg("nickname-msg", msg, "err");
         }
         this.savedNickname = nickname;
         this.renderSubtitle();
         input.value = "";
         setMsg("nickname-msg", `Saved ${nickname}.`, "ok");
      } catch {
         setMsg("nickname-msg", "Couldn't save nickname.", "err");
      } finally {
         btn.disabled = false;
      }
   }
}

customElements.define("app-profile", AppProfile);